export class ResetPassword {

  constructor(private password: string,
              private email: string,
              private token: string,
              private confirmPassword: string){}
}
